import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'replaceTilde' })
export class ReplaceTildePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (typeof value === 'undefined' || value === null || value === '') { return ''; }

    return value.toString().replace(/~/g, '<br>');
  }
}
